/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { Alert } from 'react-bootstrap'
import { useAuth } from '../auth'
import { GET_PAGEABLE_PRODUCT_BY_USERID } from '../../../urls'
import { pageRangeText, canGoPrev, canGoNext, pageItemClass } from '../../../_elfaiotbbx/helpers/PaginationHelpers'






const ListProduct: React.FC = () => {

    const { currentUser, logout } = useAuth()
    const [variant, setVariant] = useState("primary")
    const [showAlert, setShowAlert] = useState(false)
    const [alertText, setAlertText] = useState("")
    const token = currentUser?.token

    const [pageNumber, setPageNumber] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [totalPages, setTotalPages] = useState(0)
    const [totalElements, setTotalElements] = useState()

    const [productList, setProductList] = useState<any[]>([])
    const createHeader = () => {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', "" + token?.toString());
        return headers
    }


    // Bagimliliklar SADELESTI. Eskiden `[loading, pageNumber, refreshList]` idi
    // ama `setLoading` ve `setRefreshList` HIC CAGRILMIYORDU: ikisi de kalici
    // olarak false, yani effect'i yalnizca `pageNumber` tetikliyordu. Okuyan
    // kisiye var olmayan iki tetikleyici gosteriyordu.
    useEffect(() => {
        getProduct()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber]);



    /**
     * Urun listesi.
     *
     * Onceden ne `ok` denetimi ne `catch` vardi ve sayfa alanlari DOGRUDAN
     * indeksleniyordu:
     *
     *     setPageNumber(responseData["pageable"]["pageNumber"])
     *
     * Sunucu hata dondurdugunde govde bir sayfa nesnesi degil
     * `{timestamp, status, error, path}` oluyor; `["pageable"]` undefined ve
     * `["pageNumber"]` okumak TypeError atiyordu -- yani uctan gelen her hata
     * sayfayi dusuruyordu. Ayni kalibi Indikator ekraninda da duzelttik.
     */
    async function getProduct() {
        try {
            const response = await fetch(GET_PAGEABLE_PRODUCT_BY_USERID + `/?page=${pageNumber}&size=${pageSize}&userId=${currentUser?.id}`, {
                method: "GET",
                headers: createHeader(),
            })
            if (response.status === 401) { logout(); return }
            if (!response.ok) { throw new Error(`HTTP ${response.status}`) }

            const responseData = await response.json()
            const icerik = Array.isArray(responseData?.["content"]) ? responseData["content"] : []
            const sayfa = responseData?.["pageable"]

            setProductList(icerik)
            if (sayfa && typeof sayfa === 'object') {
                setPageNumber(sayfa["pageNumber"] ?? pageNumber)
                setPageSize(sayfa["pageSize"] ?? pageSize)
            }
            setTotalElements(responseData?.["totalElements"])
            setTotalPages(responseData?.["totalPages"] ?? 0)
            setShowAlert(false)
        } catch (e) {
            console.error("Urun listesi alinamadi:", e)
            // Uyari aparati ekranda ZATEN DURUYORDU ama setShowAlert/setAlertText
            // hic cagrilmiyordu, yani kalici olarak gizliydi. Artik yaziliyor.
            setVariant("danger")
            setAlertText(`Ürün listesi alınamadı (${e instanceof Error ? e.message : "bilinmeyen hata"}).`)
            setShowAlert(true)
        }
    }

    function getDeviceTypeLabelName(type:string){
        if(type === "1") return ""
        else if(type === "2") return " tetik"
        else if(type === "3") return " saat"
        else if(type === "4") return " kg"

    }
    const pageReduce = () => {

        if (canGoPrev(pageNumber, totalPages)) {

            setPageNumber(pageNumber - 1)


        }
    }
    const pageIncrease = () => {

        // pageNumber 0 TABANLI, totalPages ise bir SAYI: son gecerli indeks totalPages - 1.
    // Eskiden kosul `pageNumber < totalPages` idi, yani SON SAYFADAYKEN bir ileri
    // gidiliyor ve sunucu var olmayan sayfa icin bos liste donduruyordu -- kullanici
    // bos tablo goruyor ve geri basmak zorunda kaliyordu. Ayni hata 16 bilesende vardi
    // (2026-10-09'da hepsi birden duzeltildi); ikisi 2026-10-06'da zaten duzeltilmisti.
    if (canGoNext(pageNumber, totalPages)) {
            setPageNumber(pageNumber + 1)

        }
    }

    function getProductGroup(deviceType: string) {
        if (deviceType === "0") return "Bilinmiyor"
        else if (deviceType === "1") return "Rulman"
        else if (deviceType === "2") return "Role"
        else if (deviceType === "3") return "Kasnak"
        else if (deviceType === "4") return "Kontaktör"
        else if (deviceType === "5") return "Halat"
        else if (deviceType === "6") return "Button"
        else if (deviceType === "7") return "Kanca"
        else if (deviceType === "8") return "kasnak"
        else if (deviceType === "9") return "Motor"
        else if (deviceType === "10") return "Diğer"
        else return "Bilinmiyor"
    }
    return (


        <div>

            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='card-label fw-bold fs-3 mb-1'>Ürünler</span>
                    <span className='text-muted mt-1 fw-semibold fs-7'></span>
                </h3>
                <div className='card-toolbar'>
                    {/* begin::Menu */}

                    {/* <AsideMenuItem to='/crafted/pages/wizards/AddBlackbox' title='Ekle' hasBullet={true} /> */}
                    {/* begin::Menu 2 */}


                </div>
            </div>
            {/* end::Header */}
            {/* begin::Body */}
            <div className='card-body py-3'>
                {/* begin::Table container */}
                <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                            <tr className='fw-bold text-muted bg-light'>
                                {/* <th className='min-w-125px'>Ürün id</th> */}
                                <th className='ps-4 min-w-300px rounded-start'>Marka</th>
                                <th className='min-w-125px'>Oluşturma Tarihi</th>
                                <th className='min-w-125px'>Açıklama</th>
                                <th className='min-w-200px'>Kullanım Ömrü</th>
                                <th className='min-w-150px'>Cihaz Grup</th>
                                <th className='min-w-200px text-end rounded-end'></th>
                            </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                            {
                                (productList.length !== 0) &&
                                productList.map((product: any) => {

                                    return (
                                        <tr key={product["id"]}>
                                            {/* <td >
                                                
                                                <div className='d-flex align-items-center'>
                                                   
                                                    <div className='d-flex justify-content-start flex-column'>
                                                        <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                                                            {product.id}
                                                        </a>
                                                       
                                                    </div>
                                                </div>
                                            </td> */}
                                            <td >

                                                <div className='d-flex align-items-center'>

                                                    <div className='d-flex justify-content-start flex-column'>
                                                        <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
                                                            {product.model}
                                                        </a>
                                                        <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                                            {product.brand}
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <a href='#' className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                                                    {product.createdTime.replace("T", " ")}
                                                </a>
                                                <span className='text-muted fw-semibold text-muted d-block fs-7'>{product.city}</span>
                                            </td>
                                            <td>
                                                <a href='#' className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                                                    {product.description}
                                                </a>
                                                <span className='text-muted fw-semibold text-muted d-block fs-7'></span>
                                            </td>
                                            <td>
                                                <a href='#' className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                                                    {product.maxUsageTime + getDeviceTypeLabelName(product.deviceTimeType)}
                                                </a>
                                                <span className='text-muted fw-semibold text-muted d-block fs-7'>

                                                </span>
                                            </td>
                                            <td>
                                                <a href='#' className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                                                    {getProductGroup(product["deviceType"])}
                                                </a>
                                                <span className='text-muted fw-semibold text-muted d-block fs-7'>

                                                </span>
                                            </td>
                                            <td className='text-end'>


                                                {/* <a

                                                    className='btn btn-bg-light btn-color-muted btn-active-color-primary btn-sm px-4 me-2 '
                                                //onClick={e => deleteBlackbox(blackbox.serialNumber)}
                                                >
                                                    Sil
                                                </a> */}
                                            </td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                        {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                </div>
                {/* end::Table container */}
            </div>
            {/* begin::Body */}
            <div className='d-flex flex-stack flex-wrap pt-10'>
                <div className='fs-6 fw-bold text-gray-700'>{pageRangeText(pageNumber, pageSize, totalElements)}</div>

                <ul className='pagination'>
                    {/* Tusun GORUNUMU ile DAVRANISI ayni fonksiyondan turetiliyor.
                  Oncesinde handler'daki `if` dogru, tusun gorunumu ise her zaman
                  "tiklanabilir"di: son sayfada ileri tusu hicbir sey yapmiyor ama
                  yapabilecek gibi duruyordu, yani duzeltilmis davranis BOZUKLUK gibi
                  hissediliyordu. */}
              <li className={pageItemClass('page-item previous', canGoPrev(pageNumber, totalPages))}>
                        <a className='page-link' onClick={pageReduce}>
                            <i className='previous'></i>
                        </a>
                    </li>

                    <li className='page-item active'>
                        <a href='#' className='page-link'>
                            {pageNumber + 1}
                        </a>
                    </li>

                    <li className={pageItemClass('page-item next', canGoNext(pageNumber, totalPages))}>
                        <a className='page-link' onClick={pageIncrease}>
                            <i className='next'></i>
                        </a>
                    </li>
                </ul>
            </div>
            <Alert key={variant} variant={variant} show={showAlert}>
                {alertText}
            </Alert>
        </div>

    )
}

export { ListProduct }
